import DOMPurify from 'dompurify';

// Configure DOMPurify with safe defaults
const purifyConfig = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'a', 'img', 'div', 'span'
  ],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'target'],
  ALLOW_DATA_ATTR: false,
  KEEP_CONTENT: true
};

export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, purifyConfig);
};

export const createSafeHTML = (html: string) => {
  return { __html: sanitizeHtml(html) };
};